import DefaultValidation from '@/services/validations/DefaultValidation';
import * as Util from '@/functions/Util';

export default class FornecedorValidation extends DefaultValidation {
	validate(model, refs) {
		let validated = true;

		if (Util.isNull(model.nome )) {
			refs.nomeInput.focusedOut = true;
			validated = false;
		}
        if (Util.isNull(model.rsocial )) {
			refs.razaosocialInput.focusedOut = true;
			validated = false;
		}
        if (Util.isNull(model.endereco)) {
			refs.enderecoInput.focusedOut = true;
			validated = false;
		}
        if (Util.isNull(model.bairro)) {
			refs.bairroInput.focusedOut = true;
			validated = false;
		}
		if (Util.isNull(model.cidade)) {
			refs.cidadeInput.focusedOut = true;
			validated = false;
		}	
		if (Util.isNull(model.telefone) || !Util.validatePhone(model.telefone)) {
			refs.telefoneInput.focusedOut = true;
			validated = false;
		}
        if (Util.isNull(model.email) || !Util.validateEmail(model.email)) {
			refs.emailInput.focusedOut = true;
			validated = false;
		}
        if (Util.isNull(model.idfornecedorerp)) {
			refs.idErpInput.focusedOut = true;
			validated = false;
		}

		return validated;
	}
}
